module.exports = __webpack_public_path__ + "img/multiple-user.fa8a5cf0.svg";